var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPersonalcard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "personalcard",
    clipPath: "url(#clip0_32_1644)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "personalcard_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 1745",
    d: "M17.5 20.9H6.5C2.1 20.9 1 19.8 1 15.4V6.6C1 2.2 2.1 1.1 6.5 1.1H17.5C21.9 1.1 23 2.2 23 6.6V15.4C23 19.8 21.9 20.9 17.5 20.9Z",
    stroke: "#25CE47",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 1746",
    d: "M14.6 6.6H19.6",
    stroke: "#25CE47",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 1747",
    d: "M15.625 11H19.625",
    stroke: "#25CE47",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 1748",
    d: "M17.667 15.4H19.667",
    stroke: "#25CE47",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 1749",
    d: "M8.07294 9.975C8.43092 9.975 8.78087 9.86885 9.07852 9.66996C9.37617 9.47107 9.60817 9.18839 9.74516 8.85766C9.88216 8.52692 9.918 8.16299 9.84816 7.81189C9.77832 7.46078 9.60594 7.13827 9.3528 6.88514C9.09967 6.632 8.77716 6.45962 8.42605 6.38978C8.07495 6.31994 7.71102 6.35578 7.38028 6.49278C7.04955 6.62977 6.76686 6.86177 6.56798 7.15942C6.36909 7.45707 6.26294 7.80702 6.26294 8.165C6.26294 8.64504 6.45364 9.10542 6.79308 9.44486C7.13252 9.7843 7.5929 9.975 8.07294 9.975Z",
    stroke: "#25CE47",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 1750",
    d: "M11.462 15.678C11.3947 14.976 11.0839 14.3198 10.5834 13.823C10.083 13.3262 9.42446 13.0202 8.72204 12.958C8.2166 12.908 7.70747 12.908 7.20204 12.958C6.50023 13.0219 5.84264 13.3284 5.34252 13.8249C4.84239 14.3214 4.53103 14.9767 4.46204 15.678",
    stroke: "#25CE47",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32_1644"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.5,
    height: 21.3,
    fill: "white",
    transform: "translate(0.25 0.35)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalcard);
export default __webpack_public_path__ + "static/media/personalcard.aaf1283e8786632770e32116e875030c.svg";
export { ForwardRef as ReactComponent };